import * as React from "react";
import {Link} from "react-router-dom";

import "./load-customize-route.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {keyed}          from "@Common/react/keyed";
import {buildUrlQuery}  from "@Common/utils/build-url-query";

import {Breadcrumbs2} from "../common/breadcrumbs2/breadcrumbs2";
import {Layout}       from "../layout/layout";

export const loadCustomizeRoute = ({match=undefined, backTo=null, breadcrumbs=null, beforeNav=null, next}) => cs(
    consumeContext("cart"),
    consumeContext("routerHistory"),
    ({}, next) => <Layout className="customize-route-592">{next()}</Layout>,
    ({cart, routerHistory}, next) => <>
        {breadcrumbs && (
            <div className="header">
                {backTo && (
                    <Link className="back" to={backTo}>
                        <i className="fa fa-chevron-left"/>
                        Back
                    </Link>
                )}

                {Breadcrumbs1({
                    className: "center",
                    ...breadcrumbs,
                    itemId: (breadcrumbs?.itemId || match?.params.item_id),
                    cart: cart.value,
                    match,
                    beforeNav,
                    routerHistory
                })}
            </div>
        )}

        <div className="main">
            {cs(
                keyed(0),
                ({}) => next(),
            )}
        </div>
    </>,
    () => next(),
);

const Breadcrumbs1 = ({match, itemId, cartId, cart, query, disableNav, className, beforeNav, routerHistory}) => {
    return Breadcrumbs2({
        className,
        steps: breadcrumbSteps(routerHistory).map(({label, isActive, isDisabled, onSelect}) => ({
            label,
            active: isActive({match}),
            disabled: disableNav || isDisabled({itemId, cart, cartId}),
            onSelect: async () => {
                if (beforeNav && !(await beforeNav())) {
                    return;
                }
                onSelect({match, itemId, cartId, query});
            },
        })),
    });
};

const breadcrumbSteps = (routerHistory) => [
    {
        label: "Customize",
        isActive: ({match}) => match.path.startsWith("/customize/"),
        isDisabled: ({itemId, }) => {
            return !itemId;
        },
        onSelect: ({itemId, query}) => {
            routerHistory.push(`/customize/order/${itemId}` + buildUrlQuery(query));
        },
    },
    {
        label: "Options",
        isActive: ({match}) => match.path.startsWith("/options/"),
        isDisabled: ({itemId}) => {
            return !itemId;
        },
        onSelect: ({itemId, query}) => {
            routerHistory.push(`/options/${itemId}` + buildUrlQuery(query));
        },
    },
    {
        label: "Checkout",
        isActive: ({match}) => match.path.startsWith("/checkout/"),
        isDisabled: ({itemId, cartId, cart}) => {
            return !cartId && !cart?.items?.find((i) => i.itemId === itemId);
        },
        onSelect: ({cartId, match, query}) => {
            const cartId1 = cartId || match.params.cart_id;
            cartId1 && routerHistory.push(`/checkout/${cartId1}` + buildUrlQuery(query));
        },
    },
];
